import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DataService} from "../../services/data.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {resetFiltersByEntity, setJobFilter, toggleJobFilterValue} from "../../store/actions/filter.actions";
import {Overlayable} from "../../interfaces/overlayable";
import {take} from "rxjs";
import _ from "lodash";
import {DisplayService} from "../../services/display.service";
import {SearchbarSuggestion} from "./searchbar-suggestion";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {Router} from "@angular/router";

@UntilDestroy()
@Component({
  selector: 'brt-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent implements OnInit, Overlayable {

  @ViewChild('mainEl') mainEl!: ElementRef;
  @ViewChild('searchEl') searchEl!: ElementRef;

  @Input('placeholder') placeholder = "Suchen";
  @Input('frequentlyList') set setFrequentlyList(val: string[]) {
    this.frequentlySearchList = val;
    this.hasFrequentlySearchList = this.frequentlySearchList.length > 0;
    this.suggestionsType = this.hasFrequentlySearchList ? SuggestionsType.FREQUENTLY : SuggestionsType.NONE;
  }

  @Input('suggestions') suggestions: SearchbarSuggestion[] = [];
  @Input('emit-search-string') emitSearchString: boolean = false;

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Output('onSearchFilterClicked') onSearchFilterClicked = new EventEmitter<void>();
  @Output('onSuggestionClicked') eventOnSuggestionClicked = new EventEmitter<SearchbarSuggestion>();

  elementId = '';
  label = '';
  filterKey = '';
  searchValue = "";
  actionIconType: 'submit' | 'clear' = 'clear';

  filteredSuggestions: SearchbarSuggestion[] = [];

  suggestionsType: SuggestionsType = SuggestionsType.NONE;
  SuggestionsType = SuggestionsType;

  frequentlySearchList: string[] = [];
  hasFrequentlySearchList = false;


  isMobileOverlayOpened = false;
  debouncedSearchValueUpdateTrigger = _.debounce(() => this.onSearchValueChanged(), 10)


  @Input('job-filter-key') set setJobFilterKey(value: string) {
    if (typeof value !== 'undefined' && value.length > 0) {
      this.filterKey = value;

      this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe(response => {
        if (response !== null && response !== false) {
          this.searchValue = response;
        }
      });

    }
  }

  constructor(
    private data: DataService,
    private store: Store<AppState>,
    private display: DisplayService,
    private router: Router
  ) {
    this.elementId = Math.random().toString(36).substring(7);
  }

  ngOnInit(): void {

  }

  onSearchValueChanged(): void {
    // if (this.filterKey === '') {
    //   return;
    // }

    if(this.display.isMobileScreenSize()) {
      this.actionIconType = 'clear';
    } else {
      this.actionIconType = 'submit';
    }

    if(this.searchValue.length === 0) {
      this.store.dispatch(setJobFilter({key: this.filterKey, value: this.searchValue}));
      // console.log("resetting value to " + this.searchValue);
      this.suggestionsType = this.hasFrequentlySearchList ? SuggestionsType.FREQUENTLY : SuggestionsType.NONE;

    } else {
      this.filterSuggestions(this.searchValue);
      this.suggestionsType = SuggestionsType.FILTER;
    }

    // this.store.dispatch(setJobFilter({key: this.filterKey, value: this.searchValue}));
  }

  filterSuggestions(text: string): void {
    text = text.toLowerCase();
    if(text.length === 0) {
      this.filteredSuggestions = [];
    } else {
      this.filteredSuggestions = this.suggestions.filter((el) => {
        return el.label.toLowerCase().indexOf(text) !== -1;
      });

      this.filteredSuggestions = this.filteredSuggestions.map(el => {
        let startIndex = el.label.toLowerCase().indexOf(text);
        return {
          ...el,
          label: `${el.label.slice(0, startIndex)}<strong>${el.label.slice(startIndex, startIndex + text.length)}</strong>${el.label.slice(startIndex + text.length)}`
        }
      })
    }
  }

  setSearchValue(val: string) {
    this.searchValue = val;
    this.debouncedSearchValueUpdateTrigger();
  }

  onFrequentlyItemClicked(filterValue: string) {
    this.closeMobileOverlay();
    this.store.dispatch(setJobFilter({key: this.filterKey, value: filterValue}));
  }

  onSuggestionClicked(suggestion: SearchbarSuggestion) {
    this.closeMobileOverlay();
    this.setSearchValue("");
    this.eventOnSuggestionClicked.emit(suggestion);

    if(this.emitSearchString) {
      return;
    }

    if(suggestion.type === 'multiple') {
      this.store.dispatch(toggleJobFilterValue({key: suggestion.filterKey, value: suggestion.id}));
    } else if(suggestion.type === 'profession-link') {
      // console.log("/berufe/" + suggestion.id);
      this.router.navigateByUrl("/berufe/" + suggestion.id);
    } else {
      console.log({key: suggestion.filterKey, value: suggestion.id});
      this.store.dispatch(setJobFilter({key: suggestion.filterKey, value: suggestion.id}));
    }
  }

  closeMobileOverlay() {
    if(this.display.isMobileScreenSize()) {
      this.isMobileOverlayOpened = false;
      this.display.enableBodyScroll();
      this.display.removeElementFillVVHeight(this.mainEl.nativeElement);
    }
  }


  openMobileOverlay() {
    this.isMobileOverlayOpened = true;
    this.display.disableBodyScroll([this.mainEl.nativeElement], true);
    this.display.addElementFillVVHeight(this.mainEl.nativeElement);
  }
  onClearIconClicked($event: MouseEvent) {
    // $event.stopPropagation();
    // this.store.dispatch(resetFiltersByEntity({key: "allProfession"}));
    if(this.searchValue.length > 0) {
      this.setSearchValue("");

      if(this.isMobileOverlayOpened) {
        const searchHTMLInput = this.searchEl.nativeElement as HTMLInputElement;
        searchHTMLInput.focus({preventScroll: true});
      }
    }
    else this.closeMobileOverlay();

  }

  onFilterIconClicked($event: MouseEvent) {
    $event.stopPropagation();
    this.onSearchFilterClicked.emit();
  }

  onInputKeyUp($event: KeyboardEvent) {
    if($event.key === "Enter") {
      this.submitFullTextSearch();
    }
  }

  submitFullTextSearch() {
    this.searchValue = this.searchValue.trim();

    if(this.searchValue.length > 0) {
      this.actionIconType = 'clear';
      this.performFullTextSearch();
    }
    const searchHTMLInput = this.searchEl.nativeElement as HTMLInputElement;
    searchHTMLInput.blur();
    this.closeMobileOverlay();
  }

  performFullTextSearch() {
    // console.warn("Full text search is not implemented");

    // here update some values in store and rerender items
    this.store.dispatch(setJobFilter({key: this.filterKey, value: this.searchValue}));
  }

  onFocusOut() {
    setTimeout(() => {
      if(this.display.isMobileScreenSize()) {
        this.actionIconType = 'clear';

      } else {
        this.actionIconType = this.searchValue.length ? 'clear' : 'submit';

      }
    }, 100);
  }

  onFocusIn() {
    if(this.display.isMobileScreenSize()) {
      this.openMobileOverlay();
    }
  }

}

enum SuggestionsType {
  FREQUENTLY,
  FILTER,
  NONE
}
